module.exports = __webpack_public_path__ + "img/bg2.c18c97cf.png";